<template>
  <div class="dot" @click="showNotificationsClickEvent">
    <span class="dot__text-align">{{newNotificationCount}}</span>
  </div>
</template>

<script>
import {PopoverFactory} from '@/components/common/popover'
/**
 * When clicked, display the Notifications that are injected into this component
 * Display the notification number given to this component that are of status NEW
 */
export default {
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    deleteNotificationFunc: Function,
    actionEngine: Object
  },
  computed: {
    newNotificationCount () {
      if (this.notifications.length > 0) {
        // TODO get the constant value for the NEW
        return this.notifications.filter(n => n.status === 'new').length
      } else {
        return 0
      }
    }
  },
  methods: {
    showNotificationsClickEvent (e) {
      let target = e.currentTarget
      this.showNotifications(target)
    },
    showNotifications (target) {
      // TODO this function is still at a race condition....
      // TODO need to make this re useable so that it works with any data
      // that is being deleted from the popovers
      if (this.notifications.length > 0) {
        let popover = null
        popover = PopoverFactory.createNotification({
          direction: 'left',
          notifications: this.notifications,
          actionEngine: this.actionEngine,
          deleteNotificationFunc: (n) => {
            this.deleteNotificationFunc(n)
            popover.dismiss()
            setTimeout(() => this.showNotifications(target), 20)
          },
          parent: target
        })
      }
    }
  }
}
</script>

<style lang="scss">
.dot {
  height: 35px;
  width: 35px;
  background-color: #4CBEE7;
  border-radius: 50%;
  display: inline-block;
  text-align: center;

  // Centers the text in the circle
  &__text-align {
    position: relative;
    top: 8px;
    left: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// NotificationPoint.vue?2bb1389c